/* eslint-disable camelcase */
import axios from 'axios';
import { DEMAND_RECOMMENDATIONS_ENDPOINT, EVENT_OCCURRENCES_ENDPOINT } from '@dynameat/constants';

export const forecastDemandListRequest = (periodGuid) => axios.get(DEMAND_RECOMMENDATIONS_ENDPOINT(periodGuid));
export const saveForecastDemandListRequest = (prediction_period_guid, demand_recommendation_list) => axios.post(
  DEMAND_RECOMMENDATIONS_ENDPOINT(),
  { prediction_period_guid, demand_recommendation_list }
);
export const eventOccurrenceListRequest = (periodGuid) => axios.get(EVENT_OCCURRENCES_ENDPOINT(periodGuid));
